<template>
  <div class="cookie-container">
    <iframe
      :src="cookieUrl"
      frameborder="0"
      class="cookie-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "CookieStatement",
  computed: {
    cookieUrl() {
      const locale = this.$i18n.locale;
      if (locale === 'ja' || locale === 'jp') {
        return '/cookie_ja.html';
      }
      return '/cookie.html';
    }
  }
};
</script>

<style lang="scss" scoped>
.cookie-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.cookie-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
